<template>
  <h1 class="sr-only">John Savar Lorenzo - ابراهيم الهتاري</h1>
  <h2 class="sr-only">Web Developer - مطور ويب</h2>

  <MyEnName id="svg-my-en-name" :class="$attrs.class" />
</template>

<script setup lang="ts">
  import { MyEnName } from '..';
</script>
